
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CustomButton from '../../../../components/button';


const ForgotPassword = ({
    onPageUpdate,
    onFormSubmit,
    isLoader
}) => {
    const formik = useFormik({
        initialValues: {
            phoneNumber: '',
            password: '',

        },
        validationSchema: Yup.object({
            phoneNumber: Yup.string()
                .matches(/^\d+$/, 'Phone Number must be numeric')
                .required('Phone Number is required'),
            password: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('Password is required'),

        }),
        onSubmit: (values) => {
            console.log('Form data:', values);
            onFormSubmit(values)
        },
    });



    return (

        <div>
            <h2 className="text-2xl font-bold mb-6 text-center">Forgot Password</h2>
            <form onSubmit={formik.handleSubmit} className="space-y-4 w-[60%] mx-auto">

                {/* Mobile number */}
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">Mobile Number *</label>
                    <input
                        type="number"
                        id="phoneNumber"
                        name="phoneNumber"
                        className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.phoneNumber && formik.errors.phoneNumber ? 'border-red-500' : 'border-gray-300'}`}
                        value={formik.values.phoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        maxLength="10"
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                        <p className="text-red-500 text-sm mt-1">{formik.errors.phoneNumber}</p>
                    )}
                </div>
                <div>
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">New Password *</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.password && formik.errors.password ? 'border-red-500' : 'border-gray-300'}`}
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.password && formik.errors.password && (
                        <p className="text-red-500 text-sm mt-1">{formik.errors.password}</p>
                    )}
                </div>



                <CustomButton title={'Submit'} type="submit" loader={isLoader} />
            </form>
            <p className="mt-4 text-center text-sm text-gray-600">
                Don't have an account? <span className="text-blue-500 hover:underline" onClick={() => onPageUpdate('signUp')}>Sign Up</span>
            </p>
        </div>
    )
}

export default ForgotPassword